import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import DraggableMissions from '../DraggableMissions';
import styles from './style.module.css';

const Template3 = ({ data, skills, downloadable }) => {
  const { basics, sections } = data;

  return (
    <div className={styles.resumeContainer}>
      {/* Header Section */}
      <header className={styles.header}>
        <h1>{basics.name}</h1>
        <div className={styles.contactInfo}>
          <a href={`mailto:${basics.email}`}>{basics.email}</a> | {basics.phone}
        </div>
      </header>

      {/* Summary Section */}
      {sections?.summary && (
        <section className={styles.section}>
          <h2>{sections.summary.name}</h2>
          <p className={styles.semibold}>{sections.summary.content}</p>
        </section>
      )}

      {/* Skills Section */}
      {sections?.skills.items.length > 0 && sections.skills.items[0]?.name && (
        <section className={styles.section}>
          <h2>{sections.skills.name}</h2>
          {downloadable ? (
            <ul className={styles.skillsList}>
              {skills.list2.map((skill, index) => (
                <li key={index} className={styles.skillItem}>
                  • {skill}
                </li>
              ))}
            </ul>
          ) : (
            <Droppable droppableId="list2" direction="horizontal">
              {(provided) => (
                <ul
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={styles.skillsList}
                >
                  {skills.list2.map((skill, index) => (
                    <Draggable key={skill} draggableId={`list2-${skill}`} index={index}>
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={styles.skillItem}
                        >
                          • {skill}
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          )}
        </section>
      )}

      {/* Languages Section */}
      {sections?.languages.items.length > 0 && sections.languages.items[0]?.name && (
        <section className={styles.section}>
          <h2>{sections.languages.name}</h2>
          <ul className={styles.skillsList}>
            {sections.languages.items.map((language, index) => (
              <li key={index} className={styles.skillItem}>
                • {language.name}
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* Experience Section */}
      {sections?.experience.items.length > 0 && sections.experience.items[0]?.position && (
        <section className={styles.section}>
          <h2>{sections.experience.name}</h2>
          {sections.experience.items.map((experience, index) => (
            <div key={index} className={styles.job}>
              <h3>{experience.position}</h3>
              <h4>{experience.company} - {experience.location}</h4>
              <span>{experience.date}</span>
              <DraggableMissions
                droppableId={`list4-${index}`}
                experience={experience}
                staticPreview={downloadable}
              />
            </div>
          ))}
        </section>
      )}

      {/* Education Section */}
      {sections?.education.items.length > 0 && sections.education.items[0]?.institution && (
        <section className={styles.section}>
          <h2 >{sections.education.name}</h2>
          {sections.education.items.map((edu, index) => (
            <div key={index} className={styles.education}>
              <h3  className={styles.semibold}>{edu.studyType}</h3>
              <p className={styles.semibold}>{edu.institution} - {edu.date}</p>
            </div>
          ))}
        </section>
      )}

      {/* Certifications Section */}
      {sections?.certifications.items.length > 0 && sections.certifications.items[0]?.name && (
        <section className={styles.section}>
          <h2 >{sections.certifications.name}</h2>
          <ul>
            {sections.certifications.items.map((cert, index) => (
              <li  className={styles.semibold} key={index}>{cert.name}</li>
            ))}
          </ul>
        </section>
      )}

      {/* Projects Section */}
      {sections?.projects.items.length > 0 && sections.projects.items[0]?.name && (
        <section className={styles.section}>
          <h2>{sections.projects.name}</h2>
          {sections.projects.items.map((project, index) => (
            <div key={index}>
              <h3  className={styles.semibold}>{project.name}</h3>
              <p className={styles.semibold}>{project.description}</p>
            </div>
          ))}
        </section>
      )}

      {/* References Section */}
      {sections?.references.items.length > 0 && sections.references.items[0]?.name && (
        <section className={styles.section}>
          <h2>{sections.references.name}</h2>
          {sections.references.items.map((reference, index) => (
            <div key={index}>
              <p  className={styles.semibold}>{reference.name} - {reference.email} - {reference.phone}</p>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default Template3;
